import { v4 as uuid } from "uuid";

import { metrics } from "@north-beam/nb-common";

export const formulaAstToTokens = (
  astNode: metrics.AstNode,
): metrics.Token[] => {
  const toTokens = (node: metrics.AstNode): metrics.Token[] => {
    switch (node.type) {
      case metrics.NODE_TYPE.NUMBER:
        return [
          { type: metrics.NODE_TYPE.NUMBER, value: node.value, id: uuid() },
        ];
      case metrics.NODE_TYPE.VARIABLE:
        return [
          { type: metrics.NODE_TYPE.VARIABLE, value: node.value, id: uuid() },
        ];
      case metrics.NODE_TYPE.OPERATOR: {
        const operatorToken: metrics.Token = {
          type: metrics.NODE_TYPE.OPERATOR,
          value: node.value,
          id: uuid(),
        };
        const leftTokens = toTokens(node.left);
        const rightTokens = toTokens(node.right);

        const tokensWithParenthesis: metrics.Token[] = [
          { type: metrics.NODE_TYPE.OPERATOR, value: "(", id: uuid() },
          ...leftTokens,
          operatorToken,
          ...rightTokens,
          { type: metrics.NODE_TYPE.OPERATOR, value: ")", id: uuid() },
        ];

        return tokensWithParenthesis;
      }
      default:
        return [];
    }
  };

  const tokens = toTokens(astNode);
  // Remove parenthesis if the formula is wrapped in parenthesis
  if (tokens[0].value === "(" && tokens[tokens.length - 1].value === ")") {
    return tokens.slice(1, -1);
  }

  return tokens;
};
